import React from 'react';

import { Description } from '../../Description';

import styles from './ImageCard.Metadata.module.scss';

export interface IImageCardMetadataProps {
  label?: string;
  dataTest?: string;
}

export const ImageCardMetadata: React.SFC<IImageCardMetadataProps> = (props) => {
  return (
    <div data-test={props.dataTest} className={styles.metadata}>
      {props.label && (
        <Description variant="condensed" className={styles.label} dataTest="metadata-label">
          {props.label}
        </Description>
      )}
      <Description variant="condensed" dataTest="metadata-body">
        {props.children}
      </Description>
    </div>
  );
};
